import generatePicker from 'antd/es/date-picker/generatePicker';
import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';

import 'antd/lib/date-picker/style/css';

const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export default DatePicker;
